/* Contrato da API do painel — as 22 rotas do serviço de analytics.

   Este arquivo é o que garante o "front já mapeado": cada função declara o
   PATH e os PARÂMETROS reais do backend. Quando o serviço for portado para o
   AVA, nada aqui muda — só o flag REACT_APP_IE_MOCK (ver transport.js).

   Portado de Analytics_engajamento/dashboard/frontend/src/lib/api.ts. As
   `interface`/`type` do original foram removidas (decisão D8 — sem TypeScript,
   para não ligar type-check no build do AVA). A forma de cada resposta está
   documentada na §5 do plano de integração e nos comentários abaixo.

   O que mudou em relação ao original: `fetch` direto em same-origin `/api/*`
   deu lugar ao transport, que usa o axios configurado do AVA (com Bearer token
   e o interceptor de token expirado) ou o mock. */

import { get, post } from "./transport";

/* ---------- Endpoints ---------- */
export const api = {
  professorFiltros: () => get("/professor/filtros"),

  professorLista: p => get("/professor/lista", p),

  professorTurmas: p => get("/professor/turmas", p),

  turmaPainel: (turmaId, disciplinaId, ano, inicio, fim) =>
    get(`/professor/turma/${turmaId}`, {
      disciplina_id: disciplinaId,
      ano,
      inicio,
      fim
    }),

  turmaExecucao: (turmaId, granularidade, ano, inicio, fim) =>
    get(`/professor/turma/${turmaId}/execucao`, {
      granularidade,
      ano,
      inicio,
      fim
    }),

  turmaEngajamento: (turmaId, granularidade, ano, inicio, fim) =>
    get(`/professor/turma/${turmaId}/engajamento`, {
      granularidade,
      ano,
      inicio,
      fim
    }),

  alunoExecucao: (usuarioId, granularidade, turmaId, ano, inicio, fim) =>
    get(`/professor/aluno/${usuarioId}/execucao`, {
      granularidade,
      turma_id: turmaId,
      ano,
      inicio,
      fim
    }),

  alunoTempoOnline: (usuarioId, granularidade, ano, inicio, fim) =>
    get(`/professor/aluno/${usuarioId}/tempo-online`, {
      granularidade,
      ano,
      inicio,
      fim
    }),

  // ---- Gestor de rede ----
  // Escopo rede (grupo_id) ou região (region_id), com filtro de período opcional
  // (recorta só os indicadores de fluxo; contagens/faixa/inativos são snapshot).
  kpisGlobal: p => get("/kpis/global", p),
  escolas: p => get("/escolas", p),
  execucoesMensal: grupoId => get("/execucoes/mensal", { grupo_id: grupoId }),
  disciplinasDesempenho: (escolaId, ano, grupoId, regionId, inicio, fim) =>
    get("/disciplinas/desempenho", {
      escola_id: escolaId,
      ano,
      grupo_id: grupoId,
      region_id: regionId,
      inicio,
      fim
    }),
  regionalRanking: grupoId => get("/regional/ranking", { grupo_id: grupoId }),
  // Ranking das REDES — o nível acima das regiões, só para o Administrador
  // Educandus. Sem parâmetro: o recorte é o do token, e para qualquer outro
  // perfil o backend responde 403 (compara clientes entre si).
  gruposRanking: () => get("/grupos/ranking"),
  // Distribuição por faixa e evolução temporal em escopo de rede (grupo_id) ou
  // região (region_id) — mesmos contratos usados pelo painel da escola, só que
  // reagrupados por rede/região. A série de evolução compartilha o shape de
  // EscolaEvolucaoPonto (mes/nota_media/engajamento/conclusao).
  faixas: p => get("/faixas", p),
  evolucao: p => get("/evolucao", p),

  // ---- Painel da escola (uma unidade) ----
  escolaKpis: (escolaId, ano, inicio, fim) =>
    get(`/escola/${escolaId}/kpis`, { ano, inicio, fim }),
  escolaEvolucao: (escolaId, ano, inicio, fim) =>
    get(`/escola/${escolaId}/evolucao`, { ano, inicio, fim }),
  escolaTurmas: (escolaId, ano, inicio, fim) =>
    get(`/escola/${escolaId}/turmas`, { ano, inicio, fim }),
  escolaInativos: escolaId => get(`/escola/${escolaId}/inativos`),

  // ---- Sincronização de dados (dispara o ETL build.sh) ----
  syncLog: () => get("/sync/log"),
  syncStart: () => post("/sync")
};
